import styled from "styled-components";

export const Tittle = styled.h1.attrs({
  className: "text-2xl text-red-500 font-bold mb-6",
})``;

export const SubTittle = styled.h2.attrs({
  className: "text-xl text-red-500",
})``;
